import { z } from 'zod';

/** Format unique des erreurs de l'API. */
export const schemaErreur = z.object({
  code: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ErreurApi = z.infer<typeof schemaErreur>;
